// Codifica/decodifica o CPF como ID opaco para a URL.
// base64url dos dígitos do CPF — não é segredo (a auth fica no cookie de sessão),
// só esconde o dado pessoal da barra de endereço/histórico/logs do navegador.

function toBase64Url(s: string): string {
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(s: string): string {
  const padded = s.replace(/-/g, '+').replace(/_/g, '/');
  const pad = padded.length % 4 === 0 ? '' : '='.repeat(4 - (padded.length % 4));
  return atob(padded + pad);
}

// Preserva o formato original do CPF (a chave no banco é o CPF formatado: "140.611.391-34").
export function encodeClienteId(cpf: string): string {
  if (!cpf) return '';
  return toBase64Url(String(cpf));
}

export function decodeClienteId(id: string): string {
  if (!id) return '';
  // Compat: se for um CPF "puro" (só dígitos ou com pontuação), retorna como veio.
  if (/^\d{11}$/.test(id) || /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(id)) return id;
  try {
    const decoded = fromBase64Url(id);
    if (/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(decoded) || /^\d{11}$/.test(decoded)) {
      return decoded;
    }
    return id;
  } catch {
    return id;
  }
}
